// Default material properties
export const DEFAULT_MATERIAL_METALNESS = 0.75;
export const DEFAULT_MATERIAL_ROUGHNESS = 0.14;
export const DEFAULT_MATERIAL_ENV_MAP_INTENSITY = 1.4;

// Black material properties
export const BLACK_MATERIAL_COLOR = '#111111';
export const BLACK_MATERIAL_METALNESS = 0.92;
export const BLACK_MATERIAL_ROUGHNESS = 0.12;
export const BLACK_MATERIAL_ENV_MAP_INTENSITY = 1.6;

// Black detection threshold (lightness value)
export const BLACK_LIGHTNESS_THRESHOLD = 0.14;

// Orange material properties
export const ORANGE_MATERIAL_COLOR = '#d86a16';
export const ORANGE_MATERIAL_METALNESS = 0.88;
export const ORANGE_MATERIAL_ROUGHNESS = 0.16;
export const ORANGE_MATERIAL_ENV_MAP_INTENSITY = 1.5;

// Orange detection thresholds (HSL ranges)
export const ORANGE_HUE_MIN = 0.04;
export const ORANGE_HUE_MAX = 0.12;
export const ORANGE_SATURATION_MIN = 0.35;
